@if (help) {
  <div class="position-relative">
    @if (showText) {
      <div class="help-text-container">
        <p class="help-text">
          {{ text | translate }}
          @if (showLink) {
            <a routerLink="href">{{ linkCaption | translate }}</a>
          }
        </p>
        <div></div>
      </div>
    }
    <div
      class="help-text-i"
      [ngClass]="{ 'help-text-i-17': combobox, 'help-text-i-3': checkbox }"
      (mouseenter)="onMouseEnter()"
      (mouseleave)="onMouseLeave()"
      >
      <img alt="question mark icon" src="../../../../assets/icons/component_icons/circle-question.png" />
    </div>
  </div>
}
